module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In the dark smelly place beneath the sink. Behind the drainpipes. She has made herself small enough to hide here.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Strands of a broken spider’s web sticking to her skin. Her eyes wet with tears. Hunching her back like a little monkey. Arms closed tight around her knees raised against her small flat chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("She is just a little girl, small enough to save herself. Small enough to fit into the spider’s web. Smart enough to know that she must not cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Must not breathe. So that no one can hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So that ")]), _vm._v("he "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("can’t hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The door to the hiding place is opened, she sees a man’s feet, legs. She sees, does not see, the glisten of something dark and wet on the trouser legs. She hears, does not hear, his quick, hot panting. With a whoop of wild laughter he stoops to peer inside. He has discovered her. His face is a blur of tears. His mouth moves and is talking to her, but she hears no words. But then the door is shut again and she is alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In this way, it is determined. In the spider’s web she is allowed to live.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c98ae6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802158017-9.vue
// module id = 90
// module chunks = 0